import { css } from '@emotion/react';

export default css`
  :root {
    /* Nav */
    --nav-height-mobile: 61px;
    --nav-height-desktop: 74px;
  }
`;
